import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogActions,
    Button,
} from '@mui/material';
import { buttonStyles } from '../../styles/buttonStyles';

interface DialogProps {
    isDialogOpen: boolean;
    handleCloseDialog: () => void;
}

const NoEmailDialog: React.FC<DialogProps> = ({ isDialogOpen, handleCloseDialog }) => {
    return (
        <Dialog
            open={isDialogOpen}
            onClose={handleCloseDialog}
            aria-labelledby="dialog-title"
        >
            <DialogTitle id="dialog-title">No email address available!</DialogTitle>
            <DialogActions sx={{ justifyContent: 'center' }}>
                <Button onClick={handleCloseDialog} sx={{ ...buttonStyles.gradient, alignItems: 'center', mb: 2 }}>
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default NoEmailDialog;